import {
  Box,
  Typography,
  Button,
  Chip,
  Paper,
  IconButton
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ArrowForward, LocationOn } from "@mui/icons-material";
import { useEffect, useState } from "react";

const estadoColor = {
  "Pendiente de revisión": "warning",
  "Aprobado": "success",
  "Rechazado": "error"
};

function parsearFecha(fecha) {
  if (!fecha) return "-";
  const f = new Date(fecha);
  const dd = String(f.getDate()).padStart(2, '0');
  const MM = String(f.getMonth() + 1).padStart(2, '0');
  const yyyy = f.getFullYear();
  const HH = String(f.getHours()).padStart(2, '0');
  const mm = String(f.getMinutes()).padStart(2, '0');
  return `${dd}/${MM}/${yyyy} ${HH}:${mm}`;
}

function UPSE8Item({
  id,
  idUpse2,
  localidad,
  direccion,
  version,
  anio,
  fechaPresentacion,
  responsable,
  creado,
  estado,
  idResponsable,
  idUsuarioLogin,
  idEstado,
}) {
  const navigate = useNavigate();
  const [activarRevision, setActivarRevision] = useState(false);

  useEffect(() => {
    if (idResponsable == idUsuarioLogin && idEstado == 1) {
      setActivarRevision(true);
    }
  }, [idResponsable, idUsuarioLogin, idEstado]);

  return (
    <Paper
      elevation={1}
      sx={{
        px: 2.5,
        py: 1.5,
        mb: 1.5,
        borderRadius: 2,
        border: "1px solid #e0e0e0",
        "&:hover": { borderColor: "#bbb", boxShadow: 2 },
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 1 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, flex: 1, minWidth: 200 }}>
          <Chip label={`U8-${id}`} size="small" variant="outlined" color="primary" />
          <LocationOn fontSize="small" color="action" />
          <Typography variant="body1" fontWeight={600} noWrap>{localidad}</Typography>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          {anio && <Typography variant="body2" color="text.secondary">{anio}</Typography>}
          <Chip label={`Versión ${version}`} size="small" variant="outlined" />
        </Box>
      </Box>

      {idUpse2 && (
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
          Planificación: U2-{idUpse2}
        </Typography>
      )}

      {direccion && (
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
          Dirección / programa / unidad: {direccion}
        </Typography>
      )}

      <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
        Creado por: {creado} · Revisor: {responsable}
      </Typography>

      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mt: 1, flexWrap: "wrap", gap: 1 }}>
        <Typography variant="caption" color="text.secondary">
          {parsearFecha(fechaPresentacion)}
        </Typography>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Chip label={estado} size="small" color={estadoColor[estado] || "default"} />
          {activarRevision && (
            <Button
              size="small"
              variant="outlined"
              color="success"
              onClick={() => navigate("/UPSE8Detalle", { state: { id, validar: true } })}
            >
              Revisar
            </Button>
          )}
          <IconButton
            size="small"
            color="primary"
            onClick={() => navigate("/UPSE8Detalle", { state: { id } })}
          >
            <ArrowForward fontSize="small" />
          </IconButton>
        </Box>
      </Box>
    </Paper>
  );
}
export { UPSE8Item };
